// extracted by mini-css-extract-plugin
module.exports = {"btn-primary":"Spinner_btn-primary__zLPef","root":"Spinner_root__1oXmL","rotating":"Spinner_rotating__urJtU","light":"Spinner_light__23eM_","fadeIn":"Spinner_fadeIn__AusE_"};